import React from "react"
const total: Number = 160;
const ArrowRightIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.50004 4.99992C7.50004 4.99992 12.5 8.68236 12.5 9.99996C12.5 11.3176 7.5 14.9999 7.5 14.9999" stroke="#424242" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default ArrowRightIcon